<template>
  <div class="member-page">
    <v-container>
      <v-row justify="end">
        <v-col cols="auto">
          <div class="box">
            <v-row align="center">
              <v-col cols="auto">
                <v-avatar size="60"><img :src="user.avatar" :alt="user.name"/></v-avatar>
              </v-col>
              <v-col cols="auto">
                <div class="name font-weight-medium is-size-4">{{ user.name }}</div>
                <div class="email">{{ user.email }}</div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div class="page-body">
      <user-rental-record-table :data="data"></user-rental-record-table>
    </div>
  </div>
</template>

<script>
import { USER_RENTAL_RECORD } from '@/libs/fakeData'
import UserRentalRecordTable from '@/components/Tables/UserRentalRecord'

export default {
  components: { UserRentalRecordTable },
  data () {
    return {
      user: {
        name: 'John',
        email: 'john@gmail.com',
        avatar: 'https://cdn.vuetifyjs.com/images/john.jpg'
      },
      data: USER_RENTAL_RECORD
    }
  },
  computed: {
    path () {
      return this.$route.path
    }
  }
}
</script>

<style lang="stylus" scoped>
  .link-subtable
    text-decoration none
</style>
